import Vue from 'vue';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import { translate, toTitleCase, langUserGet, imageIdToURL, formatMSISDN, assetsImg } from './utils';
import Vue2Filters from 'vue2-filters';
import moment from 'moment'


// BootstrapVue
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

// Translation
Vue.filter('translate', translate);
Vue.filter('i18n', translate);
Vue.filter('i', translate);
Vue.filter('toTitleCase', toTitleCase);
Vue.filter('assetsImg', assetsImg);
Vue.use(Vue2Filters);

// Format MSISDN
Vue.filter('formatMSISDN', formatMSISDN);
Vue.filter('imageIdToURL', imageIdToURL);
Vue.filter('asImg', imageIdToURL);

// HAND MADE FILTERS
Vue.filter('humanize', (value) => {
	moment.locale(langUserGet() || 'en');
	// return moment(value).format("dddd D [de] MMMM");
	return moment(value).format("dddd D [de] MMMM [del] YYYY, h:mm:ss a");
});